import axios from "axios";
import { useCallback, useRef, useState } from "react";
import { API_VERSION, APP_URL, ASSIST_MAIL } from "../constants/AppConstants";
import { checkIsInsideIframe } from "../pages/utils/commonUtils";
import { message } from "antd";
import HNotification from "../components/custom/notification/HNotification";
// API call for all methods GET, POST, PUT, DELETE

export default function useHttp() {
  const [isLoading, setIsLoading] = useState(false);
  const [apiData, setApiData] = useState(null);
  const [serverError, setServerError] = useState(null);
  const lastFetchedTime = useRef();

  const fetchData = useCallback(async (url, method, body, appProperties, headers, dependencies, signal) => {
    let headerJson = {};
    var urlParams = new URLSearchParams(window.location.search);
      try {
        if (
          urlParams.has("internal") &&
          (urlParams.get("internal") === "true" || urlParams.get("internal") === true) &&
          method &&
          (method.toLowerCase?.() === "post" ||
            method.toLowerCase?.() === "put" ||
            method.toLowerCase?.() === "patch" ||
            method.toLowerCase?.() === "delete")
        ) {
          console.warn("In readOnly mode and method is not allowed");
          return;
        }
      } catch (e) {}

    let companyId = appProperties?.companyId ?? urlParams?.get("companyId") ?? dependencies?.companyId;
    const userId = appProperties?.userId ?? urlParams?.get("userId") ?? dependencies?.companyId;
    const leftServiceId = appProperties?.leftServiceId ?? urlParams.get("leftServiceId");

    if (companyId && userId) {
      headerJson = {
        "hs-orgId": companyId + "_" + userId,
      };
    } else {
      let isWebsiteLogin = appProperties?.websiteLogin;
      if (!isWebsiteLogin) {
        setIsLoading(false);
        return null;
      }
    }
    let token =
      appProperties?.userHash ?? (await appProperties?.controller?.getApplicationToken(appProperties?.userId ?? urlParams?.get("userId")));
    if (token && token !== "") {
      headerJson = { ...headerJson, "hs-token": token };
      if (!checkIsInsideIframe()) {
        const newParams = new URLSearchParams(window.location.search);
        newParams.delete("token");
        window.history.replaceState({}, "", window.location.pathname + "?" + newParams.toString());
      }
    }
    let leftserviceId = urlParams?.get("leftServiceId");
    if (leftserviceId && leftserviceId !== "") {
      headerJson = { ...headerJson, "hs-serviceId": leftserviceId };
    }

    let hsOsyncId = "";

    if (urlParams.has("osyncId")) {
      hsOsyncId = urlParams.get("osyncId");
    }
    if (hsOsyncId && hsOsyncId !== "") {
      let subAccountHeaderJson = {
        "hs-osyncId": hsOsyncId,
      };
      headerJson = { ...headerJson, ...subAccountHeaderJson };
    }
    if (headers) {
      headerJson = { ...headerJson, ...headers };
    }
    //Just for ngrok purpose -- don't delete
    // headerJson["ngrok-skip-browser-warning" ] =  "ngrok";
    setIsLoading(true);
    try {
      const resp = await axios({
        method: method,
        headers: headerJson,
        url: APP_URL + "/api/" + API_VERSION + "/" + url,
        withCredentials: true,
        data: body,
        signal: signal,
      });

      const data = JSON.stringify(resp);
      setApiData(data);
      return data;
    } catch (error) {
      if ((error?.code === "ERR_NETWORK" || error?.code === "ERR_BAD_REQUEST") && error?.config?.url.includes("/validate")) {
        appProperties?.setShowCaptchaWidget(true);
      }

      if (error.response?.status === 401) {
        if (window.location.pathname === "/logout") {
          if (appProperties?.setOtpModalState) {
            appProperties.setOtpModalState(false);
          }
          return;
        } else if (appProperties?.controller?.landingPage && window.location.pathname !== appProperties?.controller?.landingPagePathname) {
          if (companyId) {
            companyId = encodeURIComponent(companyId);
          }
          axios({
            method: "GET",
            url: `${APP_URL}/api/${API_VERSION}/account/fetcher?companyId=${companyId}&userId=${userId}&leftServiceId=${leftServiceId}`,
          })
            .then(function (fetcherResponse) {
              if (fetcherResponse?.data?.accountAvailable && fetcherResponse?.data?.userAvailable) {
                appProperties?.setOtpModalState(true);
              } else {
                appProperties?.controller?.getUrlParamsForRedirection(true, appProperties).then(function (redirectionUrlFromApp) {
                  redirectionUrlFromApp += "&prevPath=" + encodeURIComponent(window.location.pathname);
                  window.location.href = `${appProperties?.controller?.landingPagePathname}?` + redirectionUrlFromApp;
                });
              }
            })
            .catch((e) => {
              console.warn("FETCHER ERRORM", e);
            });
        } else {
          if (appProperties?.setOtpModalState) {
            appProperties?.setOtpModalState(true);
          }
        }
      } else if (API_VERSION === "v2" && error.response?.status === 403 && error?.response?.data?.error === "NO_ACCESS_TO_SUB_ACCOUNT") {
        appProperties.setPermissionDeniedToSubAccount(true);
      } else if (error?.response?.data?.error === "ACCESS_DENIED") {
        appProperties.setAccessDenied(true);
      } else if (error?.response?.data?.error === "USER_HAS_NO_ACCESS_FOR_THIS_NUMBER") {
        message.error("Looks like this number isn’t assigned to you. Please select a number linked to your account to proceed.");
      } else if (error.response?.status) {
        HNotification.notify({
          type: "error",
          message: "Error",
          description: (
            <div>
              Some unknown error occurred. Please contact
              <a target="_blank" rel="noreferrer" href={`mailto:${ASSIST_MAIL}`} style={{ paddingLeft: 5, color: "#605bff" }}>
                {ASSIST_MAIL}
              </a>
            </div>
          ),
        });
      }
      setServerError(error);
      setIsLoading(false);
      return null;
    } finally {
      setIsLoading(false);
    }
  }, []);

  const fetchAccount = useCallback(
    async (url, method, body, appProperties, header) => {
      let targetUrl = url;
      const response = await fetchData(targetUrl, method, body, appProperties, header);
      const responseJson = JSON.parse(response);
      return responseJson?.data;
    },
    [fetchData]
  );
  const pollData = useCallback(
    async (from, to, serviceId, appProperties) => {
      const d = new Date();
      let timeMS = d.getTime();
      let fetchUrl = `channels/inbox/polling`;
      if (lastFetchedTime.current) {
        d.setTime(d.getTime() + -10 * 1000);
        timeMS = d.getTime();
        lastFetchedTime.current = d.toISOString();
      } else {
        lastFetchedTime.current = d.toISOString();
      }
      fetchUrl += `?lastFetchedTime=${lastFetchedTime.current}&timeInMS=${timeMS}`;
      fetchUrl += from ? `&orgMember=${encodeURIComponent(from)}` : "";
      fetchUrl += to ? `&orgCustomer=${encodeURIComponent(to)}` : "";
      fetchUrl += serviceId ? `&serviceId=${encodeURIComponent(serviceId)}` : "";

      let response = await fetchData(fetchUrl, "GET", null, appProperties);
      response = JSON.parse(response);
      return response?.data;
    },
    [fetchData]
  );

  const fetchDataByPagination = useCallback(
    async (url, method, body, appProperties, header, limit, paginationParams, dependencies, signal) => {
      let targetUrl = url;
      if (limit) {
        targetUrl += `&limit=${limit}`;
      }
      if (paginationParams?.lastKey && paginationParams?.lastRange) {
        targetUrl += `&lastKey=${paginationParams?.lastKey}&lastRange=${paginationParams?.lastRange}`;
      }
      if (paginationParams?.cursor) {
        targetUrl += `&cursor=${encodeURIComponent(paginationParams?.cursor)}`;
      }
      const response = await fetchData(targetUrl, method, body, appProperties, header, dependencies, signal);
      const responseJson = JSON.parse(response);
      return responseJson?.data;
    },
    [fetchData]
  );

  return {
    isLoading,
    apiData,
    serverError,
    fetchData,
    fetchDataByPagination,
    pollData,
  };
}
